function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../lib/saito/ui/saito-overlay/saito-overlay');
var ThemeSwitcherOverlayTemplate = require('./theme-switcher-overlay.template');
var ThemeSwitcherOverlay = /*#__PURE__*/function () {
  function ThemeSwitcherOverlay(app, mod) {
    _classCallCheck(this, ThemeSwitcherOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod, false, true);
  }
  return _createClass(ThemeSwitcherOverlay, [{
    key: "render",
    value: function render() {
      var mod_obj = this.app.modules.returnActiveModule();
      var selected_theme = '';
      if (this.app.options.theme) {
        selected_theme = this.app.options.theme[mod_obj.returnSlug()];
      }
      this.overlay.show(ThemeSwitcherOverlayTemplate(this.app, this.mod, mod_obj.theme_options, selected_theme));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      this_self = this;
      document.querySelectorAll('.saito-modal-menu-option').forEach(function (elem) {
        elem.addEventListener('click', function (e) {
          var theme = e.currentTarget.getAttribute('data-theme');
          if (theme != null) {
            this_self.app.browser.switchTheme(theme);
            this_self.overlay.remove();
            this_self.app.connection.emit('saito-header-logo-change-request', {
              'theme': theme
            });
          }
        });
      });
    }
  }]);
}();
module.exports = ThemeSwitcherOverlay;